"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7060],{

/***/ 80560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSlot; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);
/* harmony import */ var _mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22760);
/* harmony import */ var _mui_base_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71276);
/* harmony import */ var _mui_base_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24407);
/* harmony import */ var _mui_base_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10238);
'use client';



const _excluded = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"],
  _excluded2 = ["component", "slots", "slotProps"],
  _excluded3 = ["component"];


/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */
function useSlot(
/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */
name, parameters) {
  const {
      className,
      elementType: initialElementType,
      ownerState,
      externalForwardedProps,
      getSlotOwnerState,
      internalForwardedProps
    } = parameters,
    useSlotPropsParams = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(parameters, _excluded);
  const {
      component: rootComponent,
      slots = {
        [name]: undefined
      },
      slotProps = {
        [name]: undefined
      }
    } = externalForwardedProps,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(externalForwardedProps, _excluded2);
  const elementType = slots[name] || initialElementType;

  // `slotProps[name]` can be a callback that receives the component's ownerState.
  // `resolvedComponentsProps` is always a plain object.
  const resolvedComponentsProps = (0,_mui_base_utils__WEBPACK_IMPORTED_MODULE_1__/* .resolveComponentProps */ .x)(slotProps[name], ownerState);
  const _mergeSlotProps = (0,_mui_base_utils__WEBPACK_IMPORTED_MODULE_2__/* .mergeSlotProps */ .L)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      className
    }, useSlotPropsParams, {
      externalForwardedProps: name === 'root' ? other : undefined,
      externalSlotProps: resolvedComponentsProps
    })),
    {
      props: {
        component: slotComponent
      },
      internalRef
    } = _mergeSlotProps,
    mergedProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeSlotProps.props, _excluded3);
  const ref = (0,_mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  const finalOwnerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, ownerState, slotOwnerState);
  const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
  const props = (0,_mui_base_utils__WEBPACK_IMPORTED_MODULE_5__/* .appendOwnerState */ .$)(elementType, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach(propName => {
    delete props[propName];
  });
  return [elementType, props];
}

/***/ }),

/***/ 27060:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/rootShouldForwardProp.js
var rootShouldForwardProp = __webpack_require__(14136);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContentText/dialogContentTextClasses.js


function getDialogContentTextUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDialogContentText', slot);
}
const dialogContentTextClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogContentText', ['root']);
/* harmony default export */ var DialogContentText_dialogContentTextClasses = ((/* unused pure expression or super */ null && (dialogContentTextClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js
'use client';



const _excluded = ["children", "className"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getDialogContentTextUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const DialogContentTextRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  shouldForwardProp: prop => (0,rootShouldForwardProp/* default */.Z)(prop) || prop === 'classes',
  name: 'MuiDialogContentText',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const DialogContentText = /*#__PURE__*/react.forwardRef(function DialogContentText(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDialogContentText'
  });
  const {
      className
    } = props,
    ownerState = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentTextRoot, (0,esm_extends/* default */.Z)({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className)
  }, props, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContentText_DialogContentText = (DialogContentText);
// EXTERNAL MODULE: ./node_modules/@mui/utils/useId/useId.js
var useId = __webpack_require__(89326);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(25454);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/dialogClasses.js


function getDialogUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDialog', slot);
}
const dialogClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
/* harmony default export */ var Dialog_dialogClasses = (dialogClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/DialogContext.js

const DialogContext = /*#__PURE__*/react.createContext({});
if (false) {}
/* harmony default export */ var Dialog_DialogContext = (DialogContext);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
'use client';



const Dialog_excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
















const DialogBackdrop = (0,styled/* default */.ZP)(Backdrop/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const Dialog_useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,capitalize/* default */.Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,capitalize/* default */.Z)(scroll)}`, `paperWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogUtilityClass, classes);
};
const DialogRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,capitalize/* default */.Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&::after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,capitalize/* default */.Z)(ownerState.scroll)}`], styles[`paperWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog = /*#__PURE__*/react.forwardRef(function Dialog(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClick,
      onClose,
      open,
      PaperComponent = Paper/* default */.Z,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = Fade/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Dialog_excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = Dialog_useUtilityClasses(ownerState);
  const backdropClick = react.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    if (onClick) {
      onClick(event);
    }

    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = (0,useId/* default */.Z)(ariaLabelledbyProp);
  const dialogContextValue = react.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0,esm_extends/* default */.Z)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContainer, {
        className: (0,clsx/* default */.Z)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogPaper, (0,esm_extends/* default */.Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx/* default */.Z)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog_DialogContext.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Dialog_Dialog = (Dialog);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogTitle/dialogTitleClasses.js


function getDialogTitleUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogTitle', ['root']);
/* harmony default export */ var DialogTitle_dialogTitleClasses = (dialogTitleClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
'use client';



const DialogTitle_excluded = ["className", "id"];










const DialogTitle_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogTitleUtilityClass, classes);
};
const DialogTitleRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/react.forwardRef(function DialogTitle(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDialogTitle'
  });
  const {
      className,
      id: idProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, DialogTitle_excluded);
  const ownerState = props;
  const classes = DialogTitle_useUtilityClasses(ownerState);
  const {
    titleId = idProp
  } = react.useContext(Dialog_DialogContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitleRoot, (0,esm_extends/* default */.Z)({
    component: "h2",
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: idProp != null ? idProp : titleId
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogTitle_DialogTitle = (DialogTitle);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContent/dialogContentClasses.js


function getDialogContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDialogContent', slot);
}
const dialogContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogContent', ['root', 'dividers']);
/* harmony default export */ var DialogContent_dialogContentClasses = ((/* unused pure expression or super */ null && (dialogContentClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js
'use client';



const DialogContent_excluded = ["className", "dividers"];









const DialogContent_useUtilityClasses = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${DialogTitle_dialogTitleClasses.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/react.forwardRef(function DialogContent(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDialogContent'
  });
  const {
      className,
      dividers = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, DialogContent_excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    dividers
  });
  const classes = DialogContent_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContent_DialogContent = (DialogContent);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogActions/dialogActionsClasses.js


function getDialogActionsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogActions', ['root', 'spacing']);
/* harmony default export */ var DialogActions_dialogActionsClasses = ((/* unused pure expression or super */ null && (dialogActionsClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js
'use client';



const DialogActions_excluded = ["className", "disableSpacing"];








const DialogActions_useUtilityClasses = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(style) ~ :not(style)': {
    marginLeft: 8
  }
}));
const DialogActions = /*#__PURE__*/react.forwardRef(function DialogActions(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiDialogActions'
  });
  const {
      className,
      disableSpacing = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, DialogActions_excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableSpacing
  });
  const classes = DialogActions_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogActionsRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogActions_DialogActions = (DialogActions);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronLeft.js
var Icon24UtilityChevronLeft = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityClose.js
var Icon24UtilityClose = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24ChevronLeft.js
var Icon24ChevronLeft = __webpack_require__(19957);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Close.js
var Icon24Close = __webpack_require__(91219);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/components/ModalTitle.js





const ModalTitle = ({ title, onBack, onClose, isDynamic = false, hideClose = false, }) => {
    const hasBackFunc = Boolean(onBack);
    const { isEmbraceTheme } = (0,useActiveTheme/* default */.Z)();
    return (react.createElement(Grid/* default */.ZP, { container: true, alignItems: "center", ml: -0.5, mt: -0.5, width: (theme) => `calc(100% + ${theme.spacing(1)})` },
        react.createElement(Grid/* default */.ZP, { item: true, container: true, justifyContent: "flex-start", alignItems: "flex-start", xs: 1 }, hasBackFunc && (react.createElement(IconButton/* default */.Z, { "aria-label": "Back", size: "small", onClick: () => {
                onBack === null || onBack === void 0 ? void 0 : onBack();
            } }, isEmbraceTheme ? (react.createElement(Icon24ChevronLeft/* default */.Z, { size: "20px" })) : (react.createElement(Icon24UtilityChevronLeft/* default */.Z, { size: "20px" }))))),
        react.createElement(Grid/* default */.ZP, { item: true, xs: 10 }, isDynamic && (react.createElement(Typography/* default */.Z, { component: "b", variant: "h3", color: "textPrimary", align: "center" }, title))),
        react.createElement(Grid/* default */.ZP, { item: true, container: true, justifyContent: "flex-end", alignItems: "flex-end", xs: 1 }, !hideClose && (react.createElement(IconButton/* default */.Z, { "aria-label": "Close", size: "small", onClick: (e) => onClose === null || onClose === void 0 ? void 0 : onClose(e, 'backdropClick') }, isEmbraceTheme ? react.createElement(Icon24Close/* default */.Z, { size: "20px" }) : react.createElement(Icon24UtilityClose/* default */.Z, { size: "20px" }))))));
};
/* harmony default export */ var components_ModalTitle = (ModalTitle);
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/Person.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/avatarClasses.js


function getAvatarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiAvatar', slot);
}
const avatarClasses = (0,generateUtilityClasses/* default */.Z)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
/* harmony default export */ var Avatar_avatarClasses = ((/* unused pure expression or super */ null && (avatarClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useSlot.js
var useSlot = __webpack_require__(80560);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/Avatar.js
'use client';



const Avatar_excluded = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"];










const Avatar_useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0,composeClasses/* default */.Z)(slots, getAvatarUtilityClass, classes);
};
const AvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none',
  variants: [{
    props: {
      variant: 'rounded'
    },
    style: {
      borderRadius: (theme.vars || theme).shape.borderRadius
    }
  }, {
    props: {
      variant: 'square'
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: true
    },
    style: (0,esm_extends/* default */.Z)({
      color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
      backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : (0,esm_extends/* default */.Z)({
      backgroundColor: theme.palette.grey[400]
    }, theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[600]
    })))
  }]
}));
const AvatarImg = (0,styled/* default */.ZP)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0,styled/* default */.ZP)(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});
function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = react.useState(false);
  react.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;
    if (srcSet) {
      image.srcset = srcSet;
    }
    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
const Avatar = /*#__PURE__*/react.forwardRef(function Avatar(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiAvatar'
  });
  const {
      alt,
      children: childrenProp,
      className,
      component = 'div',
      slots = {},
      slotProps = {},
      imgProps,
      sizes,
      src,
      srcSet,
      variant = 'circular'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Avatar_excluded);
  let children = null;

  // Use a hook instead of onError on the img element to support server-side rendering.
  const loaded = useLoaded((0,esm_extends/* default */.Z)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });
  const classes = Avatar_useUtilityClasses(ownerState);
  const [ImgSlot, imgSlotProps] = (0,useSlot/* default */.Z)('img', {
    className: classes.img,
    elementType: AvatarImg,
    externalForwardedProps: {
      slots,
      slotProps: {
        img: (0,esm_extends/* default */.Z)({}, imgProps, slotProps.img)
      }
    },
    additionalProps: {
      alt,
      src,
      srcSet,
      sizes
    },
    ownerState
  });
  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(ImgSlot, (0,esm_extends/* default */.Z)({}, imgSlotProps));
    // We only render valid children, non valid children are rendered with a fallback
    // We consider that invalid children are all falsy values, except 0, which is valid.
  } else if (!!childrenProp || childrenProp === 0) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarFallback, {
      ownerState: ownerState,
      className: classes.fallback
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = (Avatar);
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/components/ModalTopImage.js


const baseTopImageStyles = {
    height: '104px',
    width: '104px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
        width: '104px',
        height: '104px',
    },
};
const ModalTopImage = ({ avatarUrl, Icon }) => {
    return (react.createElement(Box/* default */.Z, { sx: (theme) => ({
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            '& + .MuiDialogContentText-root': {
                marginTop: theme.spacing(1),
            },
        }) }, Icon ? (react.createElement(Box/* default */.Z, { sx: [
            baseTopImageStyles,
            (theme) => ({
                backgroundColor: theme.palette.common.white,
            }),
        ] }, Icon)) : (react.createElement(Avatar_Avatar, { src: avatarUrl, sx: [
            baseTopImageStyles,
            (theme) => ({
                boxShadow: `0 0 0 2px ${theme.palette.common.white}`,
                marginBottom: theme.spacing(1),
            }),
        ] }))));
};
/* harmony default export */ var components_ModalTopImage = (ModalTopImage);
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/components/ModalFooter.js


const ModalFooter = ({ buttonLayout = 'row', ButtonPrimary, ButtonSecondary, Link, }) => {
    const hasLink = Boolean(Link);
    const hasButtonSecondary = Boolean(ButtonSecondary);
    return (react.createElement(Grid/* default */.ZP, { container: true, justifyContent: "center", spacing: 1, className: "centered-text" },
        buttonLayout === 'row' && (react.createElement(react.Fragment, null,
            hasButtonSecondary && (react.createElement(Grid/* default */.ZP, { container: true, direction: "row", sx: {
                    '& .MuiButton-root': {
                        width: 'unset',
                        minWidth: '128px',
                        maxWidth: '100%',
                    },
                } },
                react.createElement(Grid/* default */.ZP, { item: true, xs: 6, sx: (theme) => ({
                        padding: `${theme.spacing(0.5, 1, 0.5, 0.5)}`,
                        textAlign: 'right',
                    }) }, ButtonPrimary),
                react.createElement(Grid/* default */.ZP, { item: true, xs: 6, sx: (theme) => ({
                        padding: `${theme.spacing(0.5, 0.5, 0.5, 1)}`,
                        textAlign: 'left',
                    }) }, ButtonSecondary))),
            !hasButtonSecondary && (react.createElement(Grid/* default */.ZP, { item: true, xs: 12, className: "centered-text" }, ButtonPrimary)))),
        buttonLayout === 'column' && (react.createElement(react.Fragment, null,
            react.createElement(Grid/* default */.ZP, { item: true, xs: 12, className: "centered-text", sx: (theme) => ({ paddingBottom: theme.spacing(1) }) }, ButtonPrimary),
            hasButtonSecondary && (react.createElement(Grid/* default */.ZP, { item: true, xs: 12, className: "centered-text", pt: 1 }, ButtonSecondary)),
            !hasButtonSecondary && hasLink && (react.createElement(Grid/* default */.ZP, { item: true, xs: 12, sx: (theme) => ({ paddingTop: theme.spacing(1) }) }, Link))))));
};
/* harmony default export */ var components_ModalFooter = (ModalFooter);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kYWxGb290ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Nb2RhbC9jb21wb25lbnRzL01vZGFsRm9vdGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDMUIsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGVBQWUsQ0FBQztBQWlCckMsTUFBTSxXQUFXLEdBQUcsQ0FBQyxFQUNuQixZQUFZLEdBQUcsS0FBSyxFQUNwQixhQUFhLEVBQ2IsZUFBZSxFQUNmLElBQUksR0FDYSxFQUFFLEVBQUU7SUFDckIsTUFBTSxPQUFPLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlCLE1BQU0sa0JBQWtCLEdBQUcsT0FBTyxDQUFDLGVBQWUsQ0FBQyxDQUFDO0lBRXBELE9BQU8sQ0FDTCxvQkFBQyxJQUFJLElBQUMsU0FBUyxRQUFDLGNBQWMsRUFBQyxRQUFRLEVBQUMsT0FBTyxFQUFFLENBQUMsRUFBRSxTQUFTLEVBQUMsZUFBZTtRQUMxRSxZQUFZLEtBQUssS0FBSyxJQUFJLENBQ3pCO1lBQ0csa0JBQWtCLElBQUksQ0FDckIsb0JBQUMsSUFBSSxJQUNILFNBQVMsUUFDVCxTQUFTLEVBQUMsS0FBSyxFQUNmLEVBQUUsRUFBRTtvQkFDRixtQkFBbUIsRUFBRTt3QkFDbkIsS0FBSyxFQUFFLE9BQU87d0JBQ2QsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLFFBQVEsRUFBRSxNQUFNO3FCQUNqQjtpQkFDRjtnQkFDRCxvQkFBQyxJQUFJLElBQ0gsSUFBSSxRQUNKLEVBQUUsRUFBRSxDQUFDLEVBQ0wsRUFBRSxFQUFFLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDO3dCQUNkLE9BQU8sRUFBRSxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUMsR0FBRyxFQUFFLENBQUMsRUFBRSxHQUFHLEVBQUUsR0FBRyxDQUFDLEVBQUU7d0JBQzdDLFNBQVMsRUFBRSxPQUFPO3FCQUNuQixDQUFDLElBQ0QsYUFBYSxDQUNUO2dCQUNQLG9CQUFDLElBQUksSUFDSCxJQUFJLFFBQ0osRUFBRSxFQUFFLENBQUMsRUFDTCxFQUFFLEVBQUUsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7d0JBQ2QsT0FBTyxFQUFFLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLENBQUMsRUFBRTt3QkFDN0MsU0FBUyxFQUFFLE1BQU07cUJBQ2xCLENBQUMsSUFDRCxlQUFlLENBQ1gsQ0FDRixDQUNSO1lBQ0EsQ0FBQyxrQkFBa0IsSUFBSSxDQUN0QixvQkFBQyxJQUFJLElBQUMsSUFBSSxRQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsU0FBUyxFQUFDLGVBQWUsSUFDekMsYUFBYSxDQUNULENBQ1IsQ0FDQSxDQUNKO1FBQ0EsWUFBWSxLQUFLLFFBQVEsSUFBSSxDQUM1QjtZQUNFLG9CQUFDLElBQUksSUFDSCxJQUFJLFFBQ0osRUFBRSxFQUFFLEVBQUUsRUFDTixTQUFTLEVBQUMsZUFBZSxFQUN6QixFQUFFLEVBQUUsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUMsRUFBRSxhQUFhLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLElBQ25ELGFBQWEsQ0FDVDtZQUNOLGtCQUFrQixJQUFJLENBQ3JCLG9CQUFDLElBQUksSUFBQyxJQUFJLFFBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRSxTQUFTLEVBQUMsZUFBZSxFQUFDLEVBQUUsRUFBRSxDQUFDLElBQy9DLGVBQWUsQ0FDWCxDQUNSO1lBQ0EsQ0FBQyxrQkFBa0IsSUFBSSxPQUFPLElBQUksQ0FDakMsb0JBQUMsSUFBSSxJQUFDLElBQUksUUFBQyxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQyxFQUFFLFVBQVUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsSUFDakUsSUFBSSxDQUNBLENBQ1IsQ0FDQSxDQUNKLENBQ0ksQ0FDUixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBQ0YsZUFBZSxXQUFXLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgR3JpZCB9IGZyb20gJ0BtdWkvbWF0ZXJpYWwnO1xuXG5leHBvcnQgdHlwZSBNb2RhbEZvb3RlclByb3BzID0ge1xuICAvKipcbiAgICogVGhlIGxheW91dCB0aGUgYnV0dG9ucyByZW5kZXIgaW4uXG4gICAqIElmIGBMaW5rYCBpcyBkZWZpbmVkIHRoaXMgd2lsbCBkZWZhdWx0IHRvICdjb2x1bW4nIG90aGVyd2lzZSAncm93J1xuICAgKiBAZGVmYXVsdCAncm93J1xuICAgKi9cbiAgYnV0dG9uTGF5b3V0PzogJ2NvbHVtbicgfCAncm93JztcbiAgLyoqIFByaW1hcnkgYnV0dG9uIGNvbXBvbmVudCAqL1xuICBCdXR0b25QcmltYXJ5PzogUmVhY3QuUmVhY3ROb2RlO1xuICAvKiogU2Vjb25kYXJ5IGJ1dHRvbiBjb21wb25lbnQgKi9cbiAgQnV0dG9uU2Vjb25kYXJ5PzogUmVhY3QuUmVhY3ROb2RlO1xuICAvKiogVGhlIGxpbmsgY29tcG9uZW50ICovXG4gIExpbms/OiBSZWFjdC5SZWFjdE5vZGU7XG59O1xuXG5jb25zdCBNb2RhbEZvb3RlciA9ICh7XG4gIGJ1dHRvbkxheW91dCA9ICdyb3cnLFxuICBCdXR0b25QcmltYXJ5LFxuICBCdXR0b25TZWNvbmRhcnksXG4gIExpbmssXG59OiBNb2RhbEZvb3RlclByb3BzKSA9PiB7XG4gIGNvbnN0IGhhc0xpbmsgPSBCb29sZWFuKExpbmspO1xuICBjb25zdCBoYXNCdXR0b25TZWNvbmRhcnkgPSBCb29sZWFuKEJ1dHRvblNlY29uZGFyeSk7XG5cbiAgcmV0dXJuIChcbiAgICA8R3JpZCBjb250YWluZXIganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIiBzcGFjaW5nPXsxfSBjbGFzc05hbWU9XCJjZW50ZXJlZC10ZXh0XCI+XG4gICAgICB7YnV0dG9uTGF5b3V0ID09PSAncm93JyAmJiAoXG4gICAgICAgIDw+XG4gICAgICAgICAge2hhc0J1dHRvblNlY29uZGFyeSAmJiAoXG4gICAgICAgICAgICA8R3JpZFxuICAgICAgICAgICAgICBjb250YWluZXJcbiAgICAgICAgICAgICAgZGlyZWN0aW9uPVwicm93XCJcbiAgICAgICAgICAgICAgc3g9e3tcbiAgICAgICAgICAgICAgICAnJiAuTXVpQnV0dG9uLXJvb3QnOiB7XG4gICAgICAgICAgICAgICAgICB3aWR0aDogJ3Vuc2V0JyxcbiAgICAgICAgICAgICAgICAgIG1pbldpZHRoOiAnMTI4cHgnLFxuICAgICAgICAgICAgICAgICAgbWF4V2lkdGg6ICcxMDAlJyxcbiAgICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICB9fT5cbiAgICAgICAgICAgICAgPEdyaWRcbiAgICAgICAgICAgICAgICBpdGVtXG4gICAgICAgICAgICAgICAgeHM9ezZ9XG4gICAgICAgICAgICAgICAgc3g9eyh0aGVtZSkgPT4gKHtcbiAgICAgICAgICAgICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcoMC41LCAxLCAwLjUsIDAuNSl9YCxcbiAgICAgICAgICAgICAgICAgIHRleHRBbGlnbjogJ3JpZ2h0JyxcbiAgICAgICAgICAgICAgICB9KX0+XG4gICAgICAgICAgICAgICAge0J1dHRvblByaW1hcnl9XG4gICAgICAgICAgICAgIDwvR3JpZD5cbiAgICAgICAgICAgICAgPEdyaWRcbiAgICAgICAgICAgICAgICBpdGVtXG4gICAgICAgICAgICAgICAgeHM9ezZ9XG4gICAgICAgICAgICAgICAgc3g9eyh0aGVtZSkgPT4gKHtcbiAgICAgICAgICAgICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcoMC41LCAwLjUsIDAuNSwgMSl9YCxcbiAgICAgICAgICAgICAgICAgIHRleHRBbGlnbjogJ2xlZnQnLFxuICAgICAgICAgICAgICAgIH0pfT5cbiAgICAgICAgICAgICAgICB7QnV0dG9uU2Vjb25kYXJ5fVxuICAgICAgICAgICAgICA8L0dyaWQ+XG4gICAgICAgICAgICA8L0dyaWQ+XG4gICAgICAgICAgKX1cbiAgICAgICAgICB7IWhhc0J1dHRvblNlY29uZGFyeSAmJiAoXG4gICAgICAgICAgICA8R3JpZCBpdGVtIHhzPXsxMn0gY2xhc3NOYW1lPVwiY2VudGVyZWQtdGV4dFwiPlxuICAgICAgICAgICAgICB7QnV0dG9uUHJpbWFyeX1cbiAgICAgICAgICAgIDwvR3JpZD5cbiAgICAgICAgICApfVxuICAgICAgICA8Lz5cbiAgICAgICl9XG4gICAgICB7YnV0dG9uTGF5b3V0ID09PSAnY29sdW1uJyAmJiAoXG4gICAgICAgIDw+XG4gICAgICAgICAgPEdyaWRcbiAgICAgICAgICAgIGl0ZW1cbiAgICAgICAgICAgIHhzPXsxMn1cbiAgICAgICAgICAgIGNsYXNzTmFtZT1cImNlbnRlcmVkLXRleHRcIlxuICAgICAgICAgICAgc3g9eyh0aGVtZSkgPT4gKHsgcGFkZGluZ0JvdHRvbTogdGhlbWUuc3BhY2luZygxKSB9KX0+XG4gICAgICAgICAgICB7QnV0dG9uUHJpbWFyeX1cbiAgICAgICAgICA8L0dyaWQ+XG4gICAgICAgICAge2hhc0J1dHRvblNlY29uZGFyeSAmJiAoXG4gICAgICAgICAgICA8R3JpZCBpdGVtIHhzPXsxMn0gY2xhc3NOYW1lPVwiY2VudGVyZWQtdGV4dFwiIHB0PXsxfT5cbiAgICAgICAgICAgICAge0J1dHRvblNlY29uZGFyeX1cbiAgICAgICAgICAgIDwvR3JpZD5cbiAgICAgICAgICApfVxuICAgICAgICAgIHshaGFzQnV0dG9uU2Vjb25kYXJ5ICYmIGhhc0xpbmsgJiYgKFxuICAgICAgICAgICAgPEdyaWQgaXRlbSB4cz17MTJ9IHN4PXsodGhlbWUpID0+ICh7IHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcoMSkgfSl9PlxuICAgICAgICAgICAgICB7TGlua31cbiAgICAgICAgICAgIDwvR3JpZD5cbiAgICAgICAgICApfVxuICAgICAgICA8Lz5cbiAgICAgICl9XG4gICAgPC9HcmlkPlxuICApO1xufTtcbmV4cG9ydCBkZWZhdWx0IE1vZGFsRm9vdGVyO1xuIl19
;// CONCATENATED MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





const DefaultTextWrapper = ({ title }) => (react.createElement(Box/* default */.Z, { className: "text-content-wrapper", sx: (theme) => ({
        minHeight: '26px',
        paddingBottom: theme.spacing(1),
    }) },
    react.createElement(Typography/* default */.Z, { variant: "h2", color: "textPrimary", align: "center" }, title)));
/**
 * Modals are overlays which appear with a veil darkening the entire
 * background and blocking interaction with the rest of the application
 * until it is dismissed. Modals are used when the user needs to read
 * and absorb information, make a decision, or confirm or accept something.
 * They usually appear when the user clicks on something.
 *
 * The Dynamic Modal is responsive and can contain a variety of content. It is used when more
 * complex actions are needed from the user, and may contain inputs,
 * selectors, and buttons. On Desktop, it will appear centered on the screen
 * with a veil, the same as other modals. At sizes common for mobile web it
 * will cover the entire screen, and always include Close button with
 * an optional Back button.
 */
const Modal_Modal = (_a) => {
    var { avatarUrl, ButtonPrimary, ButtonSecondary, children, Icon, Link, onBack, onClose, open = false, hideClose = false, title, variant = 'default', buttonLayout = Link ? 'column' : 'row', maxWidth = 'sm', PaperProps } = _a, rest = __rest(_a, ["avatarUrl", "ButtonPrimary", "ButtonSecondary", "children", "Icon", "Link", "onBack", "onClose", "open", "hideClose", "title", "variant", "buttonLayout", "maxWidth", "PaperProps"]);
    const hasTopImage = Boolean(avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : Icon);
    const hasLink = Boolean(Link);
    const hasButtonPrimary = Boolean(ButtonPrimary);
    const hasButtonSecondary = Boolean(ButtonSecondary);
    const hasActions = hasButtonPrimary || hasButtonSecondary || hasLink;
    const DYNAMIC_VARIANTS = ['dynamic'];
    const isDynamic = DYNAMIC_VARIANTS.includes(variant);
    const TextOnlyContent = react.Children.map(children, (child) => (react.createElement(DialogContentText_DialogContentText, { component: "div", variant: "body2", color: "textPrimary", align: "center" }, child)));
    return (react.createElement(Dialog_Dialog, Object.assign({ open: open, onClose: onClose, maxWidth: maxWidth, PaperProps: Object.assign(Object.assign({}, PaperProps), { sx: [
                (theme) => ({
                    margin: theme.spacing(3, 2),
                    overflowY: 'visible',
                    padding: theme.spacing(2, 2),
                    [theme.breakpoints.down('sm')]: {
                        padding: theme.spacing(3, 2),
                        top: 0,
                        width: '100%',
                    },
                }),
                (theme) => isDynamic
                    ? {
                        minHeight: '200px',
                        minWidth: '420px',
                        width: '420px',
                        [theme.breakpoints.down('sm')]: {
                            margin: theme.spacing(0, 0, 0, 0),
                            minWidth: 'unset',
                            height: '100%',
                            maxHeight: '100%',
                            borderRadius: '0',
                        },
                    }
                    : {
                        width: '600px',
                        [theme.breakpoints.down('sm')]: {
                            margin: theme.spacing(0, 3, 0, 3),
                        },
                    },
                ...(Array.isArray(PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.sx) ? PaperProps.sx : [PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.sx]),
            ] }) }, rest),
        react.createElement(DialogTitle_DialogTitle, { sx: { padding: 0 } },
            react.createElement(components_ModalTitle, { title: title, isDynamic: isDynamic, hideClose: hideClose, onBack: onBack, onClose: onClose })),
        children && (react.createElement(DialogContent_DialogContent, null,
            !isDynamic && hasTopImage && react.createElement(components_ModalTopImage, { avatarUrl: avatarUrl, Icon: Icon }),
            !isDynamic && title && react.createElement(DefaultTextWrapper, { title: title }),
            isDynamic ? children : TextOnlyContent)),
        hasActions && (react.createElement(DialogActions_DialogActions, { disableSpacing: true, sx: [
                (theme) => ({
                    flexDirection: 'row',
                    padding: theme.spacing(0, 1, 3, 1),
                    textAlign: 'center',
                    '& .MuiButton-root': {
                        width: 'unset',
                        minWidth: '168px',
                        maxWidth: '100%',
                    },
                    '&.column-align': {
                        flexDirection: 'column',
                    },
                }),
            ] },
            react.createElement(components_ModalFooter, { buttonLayout: buttonLayout, ButtonPrimary: ButtonPrimary, ButtonSecondary: ButtonSecondary, Link: Link })))));
};
/* harmony default export */ var components_Modal_Modal = (Modal_Modal);
//# sourceMappingURL=data:application/json;base64,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

/***/ })

}]);